module.exports = __webpack_public_path__ + "static/img/bild_sw@2x.ef03790.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bild_sw@2x.png
// module id = hFAs
// module chunks = 1